import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Row,
  Nav,
} from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { profileLinks } from '../../../../config/profileUrls';
import {requestLogOut} from "../../../../store/actions/user";

class MobileComponent extends Component {
  render() {

    return (
      <Fragment>
        <Nav className="align-items-center ml-auto ml-md-0" navbar>
          <UncontrolledDropdown nav>
            <Row className="align-items-top">
              <DropdownToggle className="nav-link pr-0 d-inline-block cursor-pointer" color="" tag="a">
                <span className="avatar avatar-sm rounded-circle mr-0 mr-sm-3">
                  <img
                    onError={ this.props.addDefaultSrc }
                    alt={ `Avatar` }
                    src={ require('../../../../assets/images/default-avatar.png') }
                  />
                </span>
              </DropdownToggle>
            </Row>
            <DropdownMenu right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">
                  <FormattedMessage id="components.layout.navbars.profileDropdown.welcome" />
                </h6>
              </DropdownItem>
              {
                this.props.profileLinks.map((link, key) => (
                  <DropdownItem
                    key={ key }
                    href={ link.href }
                    onClick={ link.onClick }
                    id={ link.id }
                  >
                    <i className={ link.icon } />
                    <span>
                      <FormattedMessage id={ link.name } />
                    </span>
                  </DropdownItem>
                ))
              }
              <DropdownItem divider />
              <DropdownItem
                id="logout-btn"
                href="#pablo"
                onClick={
                  event => {
                    event.preventDefault();
                    this.props.requestLogOut();
                  }
                }
              >
                <i className="ni ni-user-run" />
                <span>
                  <FormattedMessage id="app.login.logout_button" />
                </span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </Fragment>
    )
  }
}

MobileComponent.defaultProps = {
  profileLinks: profileLinks,
  sidenavOpen: false,
  requestLogOut,
};

const mapStateToProps = state => ({
});

const mapActionsToProps = {
  requestLogOut,
};

const Mobile = connect(mapStateToProps, mapActionsToProps)(MobileComponent);

export { MobileComponent, Mobile };


